import { Dayjs } from 'dayjs'
import { request } from '../request'

export const chatbot = {
  getTextPrediction: function (
    idModel: string,
    date: Dayjs,
    lat: number,
    lon: number
  ) {
    return request.get(
      `api/textPrediction?model=${idModel}&date=${date.utc().format('YYYY-MM-DD')}&out=${date.utc().format('HH')}&lat=${lat}&lon=${lon}`
    )
  }
}
